<template>
  <div class="page-body">
    <div class="container-fluid px-4 sm:px-6">
      <div class="edit-profile">
        <div class="row">
          <div class="col-12 col-xl-12">
            <div class="card">
              <div class="card-header px-4 py-3 sm:px-6">
                <div class="text-neutral-500 text-lg sm:text-xl font-medium font-['Poppins'] leading-normal">
                  Perfil de {{ form.name }}
                </div>
              </div>
              <div class="card-body p-4 sm:p-6 sm:mt-5">
                <form>
                  <div class="space-y-6">
                    <!-- Sección de imagen y datos básicos -->
                    <div class="flex flex-col md:flex-row gap-6">
                      <!-- Cuadro para mostrar el logo (responsive) -->
                      <div class="w-full md:w-[250px] lg:w-[342px] h-[250px] md:h-[342px] bg-neutral-200 rounded-md border border-[#dee2e6] flex justify-center items-center relative overflow-hidden mx-auto md:mx-0">
                        <span v-if="!form.img_src" class="text-neutral-500 text-sm font-medium font-['Poppins'] absolute">
                          342 x 342
                        </span>
                        <img v-else :src="form.img_src" class="w-full h-full object-cover" alt="Logo de la empresa" />
                        <input id="imageInput" type="file" accept="image/*" class="absolute inset-0 opacity-0 cursor-pointer" />
                      </div>

                      <!-- Datos básicos en columnas para móvil -->
                      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full">
                        <div class="h-auto sm:h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                          <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">ID</label>
                          <div class="text-neutral-800 text-sm font-light font-['Poppins']">
                            {{ form.id || "No especificado" }}
                          </div>
                        </div>
                        <div class="h-auto sm:h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                          <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Email</label>
                          <div class="text-neutral-800 text-sm font-light font-['Poppins']">
                            {{ form.email || "No especificado" }}
                          </div>
                        </div>
                        <div class="h-auto sm:h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                          <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Sitio Web</label>
                          <div class="text-neutral-800 text-sm font-light font-['Poppins']">
                            {{ form.website || "No especificado" }}
                          </div>
                        </div>
                        <div class="h-auto sm:h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                          <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Nombre</label>
                          <a :href="form.slug" 
                             class="text-pink-500 text-sm font-light font-['Poppins'] hover:underline"
                             target="_blank" 
                             rel="noopener noreferrer">
                            {{ form.name || "No especificado" }}
                          </a>
                        </div>
                        <div class="h-auto sm:h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                          <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Teléfono</label>
                          <div class="text-neutral-800 text-sm font-light font-['Poppins']">
                            {{ form.phone || "No especificado" }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Sección de dirección - responsive -->
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      <div class="flex flex-col gap-4">
                        <div class="h-auto sm:h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                          <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Código Postal</label>
                          <div class="text-neutral-800 text-sm font-light font-['Poppins']">
                            {{ form.zipcode || "No especificado" }}
                          </div>
                        </div>
                        <div class="h-auto sm:h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                          <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Colonia</label>
                          <div class="text-neutral-800 text-sm font-light font-['Poppins']">
                            {{ form.neighborhood || "No especificado" }}
                          </div>
                        </div>
                      </div>
                      <div class="flex flex-col gap-4">
                        <div class="h-auto sm:h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                          <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Estado</label>
                          <div class="text-neutral-800 text-sm font-light font-['Poppins']">
                            {{ form.state || "No especificado" }}
                          </div>
                        </div>
                        <div class="h-auto sm:h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                          <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Calle</label>
                          <div class="text-neutral-800 text-sm font-light font-['Poppins']">
                            {{ form.street || "No especificado" }}
                          </div>
                        </div>
                      </div>
                      <div class="flex flex-col gap-4">
                        <div class="h-auto sm:h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                          <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Delegación</label>
                          <div class="text-neutral-800 text-sm font-light font-['Poppins']">
                            {{ form.municipality || "No especificado" }}
                          </div>
                        </div>
                        <div class="flex flex-col gap-4">
                          <div class="flex flex-col sm:flex-row gap-4">
                            <div class="h-auto sm:h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                              <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Número Exterior</label>
                              <div class="text-neutral-800 text-sm font-light font-['Poppins']">
                                {{ form.ext_number || "No especificado" }}
                              </div>
                            </div>
                            <div class="h-auto sm:h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                              <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Número Interior</label>
                              <div class="text-neutral-800 text-sm font-light font-['Poppins']">
                                {{ form.int_number || "No especificado" }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Descripción -->
                    <div class="w-full h-auto sm:h-[168px] flex-col justify-start items-start gap-1.5 inline-flex">
                      <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Descripción</label>
                      <div class="text-neutral-800 text-sm font-light font-['Poppins']">
                        {{ form.summary || "No especificado" }}
                      </div>
                    </div>

                    <!-- Sección de Redes Sociales -->
                    <div class="mt-6">
                      <h3 class="text-neutral-500 text-lg font-medium font-['Poppins'] mb-4">Redes Sociales</h3>
                      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div v-if="form.facebook" class="flex items-center flex-wrap">
                          <span class="mr-2 text-neutral-500 text-sm">Facebook:</span>
                          <a :href="form.facebook" 
                            class="text-blue-600 hover:underline text-sm break-all"
                            target="_blank" 
                            rel="noopener noreferrer">
                            {{ form.facebook }}
                          </a>
                        </div>
                        <div v-if="form.twitter" class="flex items-center flex-wrap">
                          <span class="mr-2 text-neutral-500 text-sm">Twitter:</span>
                          <a :href="form.twitter" 
                            class="text-blue-400 hover:underline text-sm break-all"
                            target="_blank" 
                            rel="noopener noreferrer">
                            {{ form.twitter }}
                          </a>
                        </div>
                        <div v-if="form.instagram" class="flex items-center flex-wrap">
                          <span class="mr-2 text-neutral-500 text-sm">Instagram:</span>
                          <a :href="form.instagram" 
                            class="text-purple-600 hover:underline text-sm break-all"
                            target="_blank" 
                            rel="noopener noreferrer">
                            {{ form.instagram }}
                          </a>
                        </div>
                        <div v-if="form.linkedin" class="flex items-center flex-wrap">
                          <span class="mr-2 text-neutral-500 text-sm">LinkedIn:</span>
                          <a :href="form.linkedin" 
                            class="text-blue-700 hover:underline text-sm break-all"
                            target="_blank" 
                            rel="noopener noreferrer">
                            {{ form.linkedin }}
                          </a>
                        </div>
                        <div v-if="form.youtube" class="flex items-center flex-wrap">
                          <span class="mr-2 text-neutral-500 text-sm">YouTube:</span>
                          <a :href="form.youtube" 
                            class="text-blue-700 hover:underline text-sm break-all"
                            target="_blank" 
                            rel="noopener noreferrer">
                            {{ form.youtube }}
                          </a>
                        </div>
                        <div v-if="form.tiktok" class="flex items-center flex-wrap">
                          <span class="mr-2 text-neutral-500 text-sm">TikTok:</span>
                          <a :href="form.tiktok" 
                            class="text-blue-700 hover:underline text-sm break-all"
                            target="_blank" 
                            rel="noopener noreferrer">
                            {{ form.tiktok }}
                          </a>
                        </div>
                      </div>
                      <div v-if="!form.facebook && !form.twitter && !form.instagram && !form.linkedin" class="text-neutral-500 text-sm">
                        No se han especificado redes sociales
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              
              <!-- Mensaje de éxito -->
              <div v-if="successMessage" class="user-alert">
                <div class="user-alert-content">
                  <div class="user-alert-text">
                    {{ successMessage }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  
  <script>
  import axios from "axios";
  import { ref, computed, watch, onMounted } from "vue";
  import { useStore } from "vuex";
  //import { useRouter } from "vue-router";
  import { useRoute } from "vue-router";
  
  export default {
    setup() {
      const store = useStore();
      const session = computed(() => store.getters.getUserSession);
      const route = useRoute();
      const companyId = computed(() => route.params.id);  // Obtener el ID del rol desde la URL
      const states = ref([]); // Movido dentro del setup
      const colonies = ref([]);
      const municipalities = ref([]);
      let toastAlert  = ref(false);
      let typeMsg     = ref("");
      let msg         = ref("");

      const form = ref({
        id: "",
        name: "",
        summary: "",
        email: "",       
        phone: "",     
        website: "",      
        slug: "",         
        zipcode: "",   
        ext_number: "",    
        int_number: "",   
        logo: "",         
        neighborhood: "", 
        state: "",       
        municipality: "",
        street: "",
        facebook: "",
        twitter: "",
        instagram: "",
        linkedin: "" 
      });
      const successMessage = ref("");
      //const router = useRouter();
  
      // Función para cargar los datos del rol cuando estamos en modo de edición
      const loadRoleData = async () => {
  if (companyId.value) {
    try {
      const token = session.value.token_api;
      if (!token) {
        console.error("No se ha encontrado el token de autenticación.");
        return;
      }

      const options = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };

      // Hacer ambas solicitudes en paralelo
      const [companyResponse, networksResponse] = await Promise.all([
        axios.get(`${process.env.VUE_APP_API_BASE_URL}/company-form/${companyId.value}`, options),
        axios.get(`${process.env.VUE_APP_API_BASE_URL}/networks/${companyId.value}`, options)
      ]);

      if (companyResponse.status === 200) {
        // Asignar los datos al formulario
        const companyData = companyResponse.data.resp.company;
        form.value = {
          ...form.value,
          id: companyData.id,
          name: companyData.name,
          summary: companyData.summary,
          email: companyData.email,
          phone: companyData.phone,
          website: companyData.website,
          slug: companyData.slug,
          zipcode: companyData.zipcode,
          img_src: companyData.logo,
          int_number: companyData.int_number,
          ext_number: companyData.ext_number,
          street: companyData.street,
          state: companyData.state,
          neighborhood: companyData.neighborhood,
          municipality: companyData.municipality,
          facebook: "",
          twitter: "",
          instagram: "",
          linkedin: "",
          youtube: "",
          tiktok: ""
        };
      }

      // Procesar redes sociales si la respuesta fue exitosa
      if (networksResponse.status === 200) {
        networksResponse.data.data.forEach(network => {
          if (network.name && network.link_company) {
            form.value[network.name.toLowerCase()] = network.link_company;
          }
        });
      }
    } catch (error) {
      console.error("Error al cargar los datos del rol:", error);
    }
  }
};
  
      // Llamar a la función cuando el componente se monta
      onMounted(() => {
        loadRoleData();
        GetState();
      });

      const GetState = async () => {
          try {
              // Construir la URL de la API desde las variables de entorno
              const url_cnn = `${process.env.VUE_APP_API_BASE_URL}/catalogue/states`;

              // Realizar la solicitud con Axios
              const response = await axios.get(url_cnn, {
                  headers: {
                      'Content-Type': 'application/json', // Establecer el tipo de contenido
                  }
              });

              // Obtener la respuesta y mapearla al formato deseado
              const resp = response.data.resp;
              states.value = resp.map(estado => ({
                  value: estado.id,       // Usando el id como valor
                  name: estado.estado     // Usando el nombre del estado
              }));
              console.log(states.value)
          } catch (error) {
              console.error(error);

              // Manejar errores específicos
              if (error.response && error.response.status === 401) {
                  console.log('Debe cerrar la sesión');
              } else {
                  console.log('Error al obtener los estados');
              }
          }
      };
      const ConsultZip = zipCode => {
        const url_cnn = `${process.env.VUE_APP_API_BASE_URL}/catalogue/cp/${zipCode}`;
        
        const options = {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${session.value.token_api}` // Reemplaza con el token correcto
          }
        };

        axios.get(url_cnn, options)
          .then(response => {
            const resp = response.data.data;

            // Verifica que el código postal retorne datos
            if (resp.length > 0) {
              // Asignar estado
              
              // Asignar municipio
              municipalities.value = [{
                value: resp[0]['municipio_id'],
                name: resp[0]['municipio'],
              }];

              // Asignar colonia
              if (resp.length === 1) {
                form.value.neighborhood = colonies.value[0].value; // Asignar el ID
              }

              colonies.value = resp.map(colony => ({
                value: colony.colonia_id || colony.id, // Usar el ID de la colonia
                name: colony.colonia
              }));
            } else {
              // Mostrar alerta si no hay resultados
              toastAlert.value = true;
              typeMsg.value = 'danger';
              msg.value = "Verifica tu código postal";
              setTimeout(() => {
                closeToast();
              }, 3000);
            }
          })
          .catch(error => {
            console.error(error);
            if (error.response && error.response.status === 401) {
              console.log('Debe cerrar la sesión');
            }
          });
      };
      
      const closeToast = async () => {
       
      };
        watch(
        () => form.value.zipcode,
        newValue => {
          if (newValue && newValue.length === 5) { // Opcional: valida que el código postal tenga 5 caracteres
            ConsultZip(newValue);
          }
        }
      );
  
      return {
        form,
        states,
        municipalities,
        colonies,
        ConsultZip,
        successMessage
      };
    }
    
  };
  </script>
  